export default __webpack_public_path__ + "static/media/Long-COVID-Postcard1-8.5x5.5in-CC-BY-NC-SA.7a19cf88.pdf";